import React from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';

const AdminLayout = () => (
    <Wrapper>
        <Content>
            <Outlet />
        </Content>
    </Wrapper>
);

export default AdminLayout;

const Wrapper = styled.div`
    min-height: 100vh;
    background: #f5f5f5;
    padding: 1.5rem;
    box-sizing: border-box;
`;

const Content = styled.div`
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
    padding: 1.25rem;
    min-height: calc(100vh - 48px);
`;
